export const lazyUpd = <T>(oSt: T, nSt: T): T => {
  return oSt === nSt ? oSt : nSt
}
